const ResultMock = () => {
  const paymentResult = [{
    id: '123456789',
    userId: '12345678954643',
    contractNumber: '1221000313135',
    costomName: '法外狂徒张三'
  }
  ]

  return {
    data: paymentResult
  }
}

export default {
  path: '/resultMock.do',
  method: 'get',
  mock: ResultMock
}
